import {ACTIVE_CHAPTER_ID} from '@/app/store/modules/app'
import {BG_ACTIVE_INDEX, BG_VISIBLE} from "src/app/store/modules/background";
import * as _ from 'lodash'

export default {
    methods: {
        gotoNextChapter() {
            const {id, number} = this.nextChapter;
            this.updateActiveChapterId(id, number)
        },
        gotoPreviousChapter() {
            const {id, number} = this.previousChapter;
            this.updateActiveChapterId(id, number)
        },
        updateActiveChapterId(id, number) {
            const {$store} = this
            $store.commit(ACTIVE_CHAPTER_ID, id)
            $store.commit(BG_ACTIVE_INDEX, number)
        },
        filterChapterById(id) {
            const {chapters} = this
            return _.find(chapters, chapter => chapter.id === id)
        },
        getChapterById(id) {
            const {chapters} = this
            return _.find(chapters, chapter => {
                return chapter.number === id
            });
        },
        setBackgroundVisible(payload) {
            const {$store} = this;
            $store.commit(BG_VISIBLE, payload);
        }
    },
    computed: {
        data() {
            const {$store} = this
            return $store.getters.data
        },
        assets() {
            const {$store} = this
            return $store.getters.public
        },
        chapters() {
            const {data} = this
            return data.chapters
        },
        chapterNameList() {
            const {chapters} = this
            return chapters.map(chapter => chapter.name)
        },
        chapterVideoSrcList() {
            const {chapters, assets} = this
            const directory = `${assets}/video/`
            return chapters.map(chapter => {
                if (chapter.hasVideo) return `${directory}${chapter.videoSrc}`
                return null
            })
        },
        chapterVideoCoverList() {
            const {chapters, assets} = this
            const directory = `${assets}/img/`
            return chapters.map(chapter => `${directory}${chapter.videoCover}`)
        },
        activeChapterIndex() {
            const {chapters, activeChapterId} = this
            return _.findIndex(chapters, chapter => {
                return chapter.id === activeChapterId
            })
        },
        activeChapterId() {
            const {$store} = this
            return $store.getters.activeChapterId
        },
        activeChapter() {
            const {chapters, activeChapterId} = this
            if (activeChapterId) {
                return _.find(chapters, chapter => {
                    return chapter.id === this.activeChapterId
                })
            } else {
                throw Error('activeChapterId nas not been defined')
            }
        },
        activeChapterArtwork() {
            const {activeChapter, assets} = this
            const directory = `${assets}/img/`
            return activeChapter.artwork.map(url => `${directory}${url}`)
        },
        firstChapter() {
            const {chapters} = this
            return chapters[0]
        },
        lastChapter() {
            const {chapters} = this
            return _.last(chapters)
        },
        nextChapter() {
            const {activeChapterIndex, chapters} = this
            if (activeChapterIndex === chapters.length - 1) {
                return this.firstChapter
            } else {
                return chapters[activeChapterIndex + 1]
            }
        },
        previousChapter() {
            const {activeChapterIndex, chapters} = this
            if (activeChapterIndex === 0) {
                return this.lastChapter
            } else {
                return chapters[activeChapterIndex - 1]
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/mixins/ChapterUtils.js